export default __webpack_public_path__ + "static/media/QAT.d264947c.svg";